import React, { Fragment, useState } from 'react';
import { Container, Row, Col, Form, Table, Card } from 'react-bootstrap';
import { FaMagnifyingGlass, FaXmark } from "react-icons/fa6";
import { formatoMonto, formatFecha } from '../../../../../common/Formatos';


const DestinatarioPago = ({ cfg_form, destinatariosPago = [] }) => {
    const [destinatarioIndex, setDestinatarioIndex] = useState(null);
    const [destinatarioPago, setDestinatarioPago] = useState({});

    const handleVerDestinatario = (destinatario, index) => {
        setDestinatarioIndex(index);
        setDestinatarioPago(destinatario);
    };

    return (
        <Fragment>
            <Container>
                <Row className="mt-2">
                    <Col>
                        <Table striped hover className="table destinatarios-table">
                            <thead>
                                <tr>
                                    <th>{cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-tipodest"]}</th>
                                    <th>{cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-rutdest"]}</th>
                                    <th>{cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-nomdest"]}</th>
                                    <th>{cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-emaildest"]}</th>
                                    <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-monto"]}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {destinatariosPago.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className="text-center">Sin destinatarios</td>
                                    </tr>
                                ) : (
                                    destinatariosPago.map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.glosaTipoDestinatario}</td>
                                            <td>{row.rutDestinatario}</td>
                                            <td>{row.nombreDestinatario}</td>
                                            <td>{row.emailDestinatario}</td>
                                            <td>{row.montoPago ? formatoMonto(row.montoPago) : ''}</td>
                                            <td className="text-center">
                                                <FaMagnifyingGlass
                                                    size={20}
                                                    color='gray'
                                                    title="Ver Destinatario"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleVerDestinatario(row, index)}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </Col>
                </Row>

                {destinatarioIndex !== null && (
                    <Card className='mb-2'>
                        <Card.Header as='h6' className='text-center' style={{ backgroundColor: '#4F517A', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                            Destinatario de Pago
                            <FaXmark
                                size={18}
                                title="Cerrar"
                                style={{ cursor: 'pointer', position: 'absolute', right: '12px' }}
                                onClick={() => setDestinatarioIndex(null)}
                            />
                        </Card.Header>
                        <Card.Body>
                            <Container>
                                <Row>
                                    <Col md='3'>
                                        <Form.Label className="label">
                                            {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-tipodest"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>{destinatarioPago.glosaTipoDestinatario}</Form.Text>
                                    </Col>
                                    <Col md='3'>
                                        <Form.Label className="label">
                                            {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-rutdest"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>{destinatarioPago.rutDestinatario}</Form.Text>
                                    </Col>
                                    <Col md='3'>
                                        <Form.Label className="label">
                                            {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-nomdest"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>{destinatarioPago.nombreDestinatario}</Form.Text>
                                    </Col>
                                    <Col md='3'>
                                        <Form.Label className="label">
                                            {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-emaildest"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>{destinatarioPago.emailDestinatario}</Form.Text>
                                    </Col>
                                </Row>
                                {(destinatarioPago.parentesco || destinatarioPago.fechaNacimiento || (destinatarioPago.edad !== null && destinatarioPago.edad !== undefined && destinatarioPago.edad !== '')) && (
                                    <Row className='mt-2'>
                                        {destinatarioPago.parentesco && (
                                            <Col md='3'>
                                                <Form.Label className="label">
                                                    {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-parentesco"]}
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3'>{destinatarioPago.glosaParentesco}</Form.Text>
                                            </Col>
                                        )}
                                        {destinatarioPago.fechaNacimiento && (
                                            <Col md='3'>
                                                <Form.Label className="label">
                                                    {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-fechanac"]}
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3'>{formatFecha(destinatarioPago.fechaNacimiento)}</Form.Text>
                                            </Col>
                                        )}
                                        {destinatarioPago.edad !== null && destinatarioPago.edad !== undefined && destinatarioPago.edad !== '' && (
                                            <Col md='2'>
                                                <Form.Label className="label">
                                                    {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-edad"]}
                                                </Form.Label>
                                                <br />
                                                <Form.Text className='mb-3'>{destinatarioPago.edad}</Form.Text>
                                            </Col>
                                        )}
                                    </Row>
                                )}
                                <Row className='mt-2'>
                                    <Col>
                                        <Form.Label className="label">
                                            {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-mediopagodest"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>{destinatarioPago.glosaMedioPago}</Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className="label">
                                            {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-instfinandest"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>{destinatarioPago.glosaInstFinanciera}</Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className="label">
                                            {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-tipoctadest"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>{destinatarioPago.glosaTipoCuentaFinanciera}</Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className="label">
                                            {cfg_form && cfg_form["modalpagoindemnizar-tab-destpago-nroctadest"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>{destinatarioPago.numeroCuenta}</Form.Text>
                                    </Col>
                                    <Col>
                                        <Form.Label className="label">
                                            {cfg_form && cfg_form["modalpagoindemnizar-grilla-monto"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>{destinatarioPago.montoPago ? formatoMonto(destinatarioPago.montoPago) : ''}</Form.Text>
                                    </Col>
                                </Row>                                
                            </Container>
                        </Card.Body>
                    </Card>
                )}
            </Container>

            <hr className='mt-3 mb-0' />

            <style type='text/css'>
                {`
                    .label {
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .destinatarios-table thead th {
                        background-color: #4F517A;
                        color: white;
                    }
                `}
            </style>
        </Fragment>
    );
};

export default DestinatarioPago;
